export enum NavBarState {
  COMPLETE,
  INCOMPLETE,
  INCORRECT
}

export interface INavBarMenuState {
  state: NavBarState
}

export interface INavBarState {
  serviceDetails: INavBarMenuState,
  serviceExceptions: INavBarMenuState,
  serviceOperations: INavBarMenuState
}
